import React, { useEffect, useRef } from "react";
import "./style.css";

export default function PlayYoutube(props) {
	// Substitua os valores deste array pelos IDs dos seus vídeos
	const videos = props.vid;

	const startVideoLink = props.startVideoLink;
	const videoIds = videos.map((video) => video.link);
	const playerRef = useRef(null);
	let currentVideoIndex = videos.findIndex((video) => video.link === startVideoLink);

	useEffect(() => {
		// Carrega a API do YouTube Player
		const script = document.createElement("script");
		script.src = "https://www.youtube.com/iframe_api";
		document.body.appendChild(script);

		// Cria uma função global para ser chamada quando a API estiver pronta
		window.onYouTubeIframeAPIReady = () => {
			// Cria um novo player do YouTube
			playerRef.current = new window.YT.Player("player", {
				videoId: videoIds[currentVideoIndex],
				events: {
					onStateChange: (event) => {
						if (event.data === window.YT.PlayerState.ENDED) {
							// Carrega e reproduz o próximo vídeo da lista
							currentVideoIndex = (currentVideoIndex + 1) % videoIds.length;
							playerRef.current.loadVideoById(videoIds[currentVideoIndex]);

							// Para a reprodução do vídeo e oculta o player
							// playerRef.current.stopVideo();
							// playerRef.current.getIframe().style.display = "none";
						}
					},
				},
			});
		};

		return () => {
			// Remove o script da API do YouTube Player
			script.remove();

			// Remove o player do YouTube
			if (playerRef.current) {
				playerRef.current.destroy();
			}
		};
	}, []);

	useEffect(() => {
		// Atualiza o índice do vídeo atual
		currentVideoIndex = videos.findIndex((video) => video.link === startVideoLink);

		// Carrega e reproduz o novo vídeo
		if (playerRef.current) {
			playerRef.current.loadVideoById(videoIds[currentVideoIndex]);
		}
	}, [startVideoLink]);

	return <div className="video-iframe" id="player"></div>;
}

// import React, { useEffect, useRef } from "react";
// import "./style.css";

// export default function PlayYoutube(props) {
// 	// Substitua os valores deste array pelos IDs dos seus vídeos
// 	const videos = props.vid;

// 	const startVideoLink = props.startVideoLink;
// 	const videoIds = videos.map((video) => video.link);
// 	const playerRef = useRef(null);
// 	let currentVideoIndex = videos.findIndex((video) => video.link === startVideoLink);

// 	useEffect(() => {
// 		// Carrega a API do YouTube Player
// 		const script = document.createElement("script");
// 		script.src = "https://www.youtube.com/iframe_api";
// 		document.body.appendChild(script);

// 		// Cria uma função global para ser chamada quando a API estiver pronta
// 		window.onYouTubeIframeAPIReady = () => {
// 			// Cria um novo player do YouTube
// 			playerRef.current = new window.YT.Player("player", {
// 				videoId: videoIds[currentVideoIndex],
// 				events: {
// 					onStateChange: (event) => {
// 						if (event.data === window.YT.PlayerState.ENDED) {
// 							// Carrega e reproduz o próximo vídeo da lista
// 							currentVideoIndex = (currentVideoIndex + 1) % videoIds.length;
// 							playerRef.current.loadVideoById(videoIds[currentVideoIndex]);

// 							// Para a reprodução do vídeo e oculta o player
// 							// playerRef.current.stopVideo();
// 							// playerRef.current.getIframe().style.display = "none";
// 						}
// 					},
// 				},
// 			});
// 		};
// 	}, []);

// 	return (
// 		<div className="video-container">
// 			<div className="video-iframe" id="player"></div>
// 		</div>
// 	);
// }

// const videos = [
// 	{
// 		assunto: "Cadastrando novas promoções",
// 		descricao: "CADASTRO DE PROMOÇÕES",
// 		id: 1,
// 		link: "3HSoniK6czA",
// 		titulo: "CADASTRO DE PROMOÇÕES",
// 	},
// 	{
// 		assunto: "Editando Habilintando e desabilintando promoções",
// 		descricao: "CADASTRO DE PROMOÇÕES",
// 		id: 2,
// 		link: "p0vM9iINl28",
// 		titulo: "EDITAR PROMOÇÕES",
// 	},
// 	{
// 		assunto: "Verificar se o produto esta em promoção na notinha e no cadastro",
// 		descricao: "CADASTRO DE PROMOÇÕES",
// 		id: 3,
// 		link: "x-xTttimcNk",
// 		titulo: "PROMOÇÃO TELA DE VENDA",
// 	},
// ];
